/**
 * @packageDocumentation
 * @module dom/is
 */

export interface IsCustomElement {
  /**
   * Is the element a custom element?
   * @param el is the node or element a custom element
   */
  (el: Element | Node): el is Element;
}

/**
 * { @link IsCustomElement }
 */
export default (el: Element | Node | Object): el is HTMLElement => {
  if (!el) {
    return false;
  }

  const localName = el['localName'];
  const isDefined = customElements.get(localName) != null;
  const isCustomElement = localName.indexOf('-') >= 0;

  return isCustomElement && isDefined;
};
